<script>

    import { toast } from 'bulma-toast'
    import { userStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Button from '../$components/button.svelte'
    import DetailsCard from '../$components/details.card.svelte'

    let loading = false

    async function disabledClientsAdviser() {

        loading = true
        const resp = await UsersService.disabledClientsAdviser($userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Clientes desactivados', type: 'is-success'})
    }

</script>

<DetailsCard title="Desactivar clientes">
    <div class="columns">
        <div class="column">
            Desactivar clientes del asesor
        </div>
        <div class="column is-narrow ml-auto">
            <Button on:click={disabledClientsAdviser} text="Desactivar clientes del asesor" icon="trash" color="primary" {loading} />
        </div>
    </div>
</DetailsCard>